import { City } from './city';

export class ReservationCity {
    id: string;
    reservationId: string;
    city: City;
    cityId: string;
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/reservation-city.ts